import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const StockTypesQuery = graphql(/* GraphQL */ `
  query stockTypes($offset: Int, $limit: Int) {
    stockTypes(offset: $offset, limit: $limit) {
      ...StockTypesPaged
    }
  }
`);
